// Set global variables
if (!window.KnowitOptimizelyFramework) {
  window.KnowitOptimizelyFramework = {
    Vimeo: null,
    YouTube: null,
    BlockMediaScriptIsInitialized: false,
  };
}

// Detect Safari and add a class to <body> for Safari-specific styling
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  document.body.classList.add("is-safari");
}

// Imports
import "@features/Layout/Features/Header/Features/Menu/Scripts/menu";
import "@features/Shared/SideMenu/Scripts/side-menu";
import "@features/Layout/Features/Header/Features/Disturbance/Scripts/disturbance";
import "@features/Shared/Forms/Scripts/form-elements-main";
import "@features/Shared/PageUtilities/Scripts/print-button";
import "@utils/normalize-letter-anchors";
import "@features/Shared/Vizzit/Scripts/vizzit-set-cookie";